<template>
    <div>
        <headerNavbar title="体检人员管理" />
        <profileList />
    </div>
</template>


<script>
    import profileList from '@/components/profileList';
    import headerNavbar from '@/views/components/headerNavbar';
    export default {
        components: {
            profileList,
            headerNavbar
        },
        data() {
            return {}
        },
        mounted() {

        },
    }
</script>